import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["password", "confirmation", "message", "submit"]
  static values = { mismatch: String }

  connect() {
    this.validate()
  }

  validate() {
    const password = this.passwordTarget.value
    const confirmation = this.confirmationTarget.value
    const hasConfirmation = confirmation.length > 0
    const matches = password === confirmation
    const valid = !hasConfirmation || matches

    this.confirmationTarget.setCustomValidity(valid ? "" : this.mismatchValue)
    this.confirmationTarget.classList.toggle("border-rose-400", !valid)
    this.confirmationTarget.classList.toggle("focus:border-rose-500", !valid)
    this.messageTarget.classList.toggle("hidden", valid)
    this.submitTarget.disabled = !matches
  }

  validateOnSubmit(event) {
    this.validate()

    if (!this.element.checkValidity()) {
      event.preventDefault()
      this.element.reportValidity()
    }
  }
}
